import React from "react";

import "../../style/Reusable.css";
import "../../style/components/IngredientList.css";
import "../../style/components/HistorySlide.css";

import LazyImage from "../generics/LazyImage";
import CloseButton from "../generics/CloseButton";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";

function IngredientBlogMobile({ ingredient, handleBack, ingredientText }) {
  const { images, content, title } = ingredient;
  return (
    <div>
      <CloseButton onClick={() => handleBack(true)} />
      {content.map((paragraph, index) => (
        <div key={index}>
          <div
            className="ingredient-image-mobile"
            style={{ marginTop: images[index] ? (index ? 36 : 0) : 0 }}
          >
            <LazyImage
              className="ingredient-lazy-image zoom"
              alt=""
              imageSrc={images[index]}
            />
          </div>
          <div
            className="ingredient-details-card"
            style={{ margin: images[index] ? "60px 24px 0" : "0 24px" }}
          >
            {index === 0 && <h1 style={{ textAlign: "left" }}>{title}</h1>}
            <div className="ingredient-card-text">
              <div className="body-b2 ingredient-text-body">{paragraph}</div>
              <br />
            </div>
          </div>
        </div>
      ))}
      <div className="other-ingredient-controller-mobile clickable">
        <div
          className="ingredient-details-card ingredient-controller-label-mobile cap-r15"
          style={{ margin: "4px auto" }}
        >
          <div
            className="ingredient-controller-button"
            onClick={() => handleBack()}
          >
            {ingredientText.buttonText.listing}
            <KeyboardArrowRightRoundedIcon style={{ marginBottom: 2 }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IngredientBlogMobile;
